// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AuthenticationGetUserData,
  AuthenticationGetUserResponses,
  AuthenticationLoginData,
  AuthenticationLoginResponses,
  AuthenticationLogoutData,
  AuthenticationLogoutResponses,
  AuthenticationRefreshData,
  AuthenticationRefreshResponses,
  CaslGetRulesData,
  CaslGetRulesResponses,
  ContactRequestsCreateData,
  ContactRequestsCreateResponses,
  HealthCheckData,
  HealthCheckErrors,
  HealthCheckResponses,
  InvitationsAcceptData,
  InvitationsAcceptResponses,
  InvitationsReinviteData,
  InvitationsReinviteResponses,
  OrganizationsCreateData,
  OrganizationsCreateOrganizationUserData,
  OrganizationsCreateOrganizationUserResponses,
  OrganizationsCreateResponses,
  OrganizationsFindAllData,
  OrganizationsFindAllResponses,
  OrganizationsFindOneData,
  OrganizationsFindOneOrganizationUserData,
  OrganizationsFindOneOrganizationUserResponses,
  OrganizationsFindOneResponses,
  OrganizationsRemoveData,
  OrganizationsRemoveOrganizationUserData,
  OrganizationsRemoveOrganizationUserResponses,
  OrganizationsRemoveResponses,
  OrganizationsUpdateData,
  OrganizationsUpdateOrganizationUserData,
  OrganizationsUpdateOrganizationUserResponses,
  OrganizationsUpdateResponses,
  ParkAndRideFacilitiesCreateData,
  ParkAndRideFacilitiesCreateResponses,
  ParkAndRideFacilitiesExportCsvData,
  ParkAndRideFacilitiesExportCsvResponses,
  ParkAndRideFacilitiesFindAllAuditsData,
  ParkAndRideFacilitiesFindAllAuditsResponses,
  ParkAndRideFacilitiesFindAllData,
  ParkAndRideFacilitiesFindAllResponses,
  ParkAndRideFacilitiesFindOneAuditData,
  ParkAndRideFacilitiesFindOneAuditResponses,
  ParkAndRideFacilitiesFindOneData,
  ParkAndRideFacilitiesFindOneResponses,
  ParkAndRideFacilitiesRemoveData,
  ParkAndRideFacilitiesRemoveResponses,
  ParkAndRideFacilitiesUpdateData,
  ParkAndRideFacilitiesUpdateResponses,
  ParkingDataFindAllLatestParkAndRideFacilityDataData,
  ParkingDataFindAllLatestParkAndRideFacilityDataResponses,
  ParkingDataFindAllLatestParkingFacilityDataData,
  ParkingDataFindAllLatestParkingFacilityDataResponses,
  ParkingDataFindAllParkAndRideFacilityDataData,
  ParkingDataFindAllParkAndRideFacilityDataResponses,
  ParkingDataFindAllParkingFacilityDataData,
  ParkingDataFindAllParkingFacilityDataResponses,
  ParkingFacilitiesCreateData,
  ParkingFacilitiesCreateResponses,
  ParkingFacilitiesExportCsvData,
  ParkingFacilitiesExportCsvResponses,
  ParkingFacilitiesFindAllAuditsData,
  ParkingFacilitiesFindAllAuditsResponses,
  ParkingFacilitiesFindAllData,
  ParkingFacilitiesFindAllResponses,
  ParkingFacilitiesFindOneAuditData,
  ParkingFacilitiesFindOneAuditResponses,
  ParkingFacilitiesFindOneData,
  ParkingFacilitiesFindOneResponses,
  ParkingFacilitiesRemoveData,
  ParkingFacilitiesRemoveResponses,
  ParkingFacilitiesUpdateData,
  ParkingFacilitiesUpdateResponses,
  PasswordResetInitializeData,
  PasswordResetInitializeResponses,
  PasswordResetSubmitData,
  PasswordResetSubmitResponses,
  StationsCreateData,
  StationsCreateResponses,
  StationsFindAllAuditsData,
  StationsFindAllAuditsResponses,
  StationsFindAllData,
  StationsFindAllResponses,
  StationsFindOneAuditData,
  StationsFindOneAuditResponses,
  StationsFindOneData,
  StationsFindOneResponses,
  StationsRemoveData,
  StationsRemoveResponses,
  StationsUpdateData,
  StationsUpdateResponses,
  UsersCreateData,
  UsersCreateResponses,
  UsersFindAllData,
  UsersFindAllResponses,
  UsersFindOneData,
  UsersFindOneResponses,
  UsersRemoveData,
  UsersRemoveResponses,
  UsersUpdateData,
  UsersUpdateResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const backendApiHealthCheck = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckData, ThrowOnError>,
) =>
  (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({
    url: '/api/health',
    ...options,
  });

export const backendApiAuthenticationLogout = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationLogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<AuthenticationLogoutResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/authentication',
    ...options,
  });

export const backendApiAuthenticationGetUser = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationGetUserData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuthenticationGetUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/authentication',
    ...options,
  });

export const backendApiAuthenticationLogin = <ThrowOnError extends boolean = false>(
  options: Options<AuthenticationLoginData, ThrowOnError>,
) =>
  (options.client ?? client).post<AuthenticationLoginResponses, unknown, ThrowOnError>({
    url: '/api/authentication',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiAuthenticationRefresh = <ThrowOnError extends boolean = false>(
  options: Options<AuthenticationRefreshData, ThrowOnError>,
) =>
  (options.client ?? client).post<AuthenticationRefreshResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-refresh',
        type: 'apiKey',
      },
    ],
    url: '/api/authentication/refresh',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiPasswordResetInitialize = <ThrowOnError extends boolean = false>(
  options: Options<PasswordResetInitializeData, ThrowOnError>,
) =>
  (options.client ?? client).post<PasswordResetInitializeResponses, unknown, ThrowOnError>({
    url: '/api/password-reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiPasswordResetSubmit = <ThrowOnError extends boolean = false>(
  options: Options<PasswordResetSubmitData, ThrowOnError>,
) =>
  (options.client ?? client).patch<PasswordResetSubmitResponses, unknown, ThrowOnError>({
    url: '/api/password-reset/{authenticationTokenId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiUsersFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<UsersFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<UsersFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/users',
    ...options,
  });

export const backendApiUsersCreate = <ThrowOnError extends boolean = false>(
  options: Options<UsersCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<UsersCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiUsersRemove = <ThrowOnError extends boolean = false>(
  options: Options<UsersRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<UsersRemoveResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/users/{userId}',
    ...options,
  });

export const backendApiUsersFindOne = <ThrowOnError extends boolean = false>(
  options: Options<UsersFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<UsersFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/users/{userId}',
    ...options,
  });

export const backendApiUsersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UsersUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiCaslGetRules = <ThrowOnError extends boolean = false>(
  options?: Options<CaslGetRulesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<CaslGetRulesResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/casl',
    ...options,
  });

export const backendApiInvitationsReinvite = <ThrowOnError extends boolean = false>(
  options: Options<InvitationsReinviteData, ThrowOnError>,
) =>
  (options.client ?? client).post<InvitationsReinviteResponses, unknown, ThrowOnError>({
    url: '/api/invitations/{userId}',
    ...options,
  });

export const backendApiInvitationsAccept = <ThrowOnError extends boolean = false>(
  options: Options<InvitationsAcceptData, ThrowOnError>,
) =>
  (options.client ?? client).patch<InvitationsAcceptResponses, unknown, ThrowOnError>({
    url: '/api/invitations/{authenticationTokenId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationsFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<OrganizationsFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations',
    ...options,
  });

export const backendApiOrganizationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrganizationsCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsRemove = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<OrganizationsRemoveResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations/{organizationId}',
    ...options,
  });

export const backendApiOrganizationsFindOne = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations/{organizationId}',
    ...options,
  });

export const backendApiOrganizationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<OrganizationsUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations/{organizationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsCreateOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsCreateOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrganizationsCreateOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations/{organizationId}/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsRemoveOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsRemoveOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<OrganizationsRemoveOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations/{organizationId}/users/{userId}',
    ...options,
  });

export const backendApiOrganizationsFindOneOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsFindOneOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsFindOneOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations/{organizationId}/users/{userId}',
    ...options,
  });

export const backendApiOrganizationsUpdateOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsUpdateOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).patch<OrganizationsUpdateOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'park-ride-hessen-access',
        type: 'apiKey',
      },
      { scheme: 'bearer', type: 'http' },
    ],
    url: '/api/organizations/{organizationId}/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiParkingFacilitiesFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<ParkingFacilitiesFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkingFacilitiesFindAllResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities',
    ...options,
  });

export const backendApiParkingFacilitiesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ParkingFacilitiesCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<ParkingFacilitiesCreateResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiParkingFacilitiesExportCsv = <ThrowOnError extends boolean = false>(
  options?: Options<ParkingFacilitiesExportCsvData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkingFacilitiesExportCsvResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities/export.csv',
    ...options,
  });

export const backendApiParkingFacilitiesRemove = <ThrowOnError extends boolean = false>(
  options: Options<ParkingFacilitiesRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ParkingFacilitiesRemoveResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities/{parkingFacilityId}',
    ...options,
  });

export const backendApiParkingFacilitiesFindOne = <ThrowOnError extends boolean = false>(
  options: Options<ParkingFacilitiesFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<ParkingFacilitiesFindOneResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities/{parkingFacilityId}',
    ...options,
  });

export const backendApiParkingFacilitiesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ParkingFacilitiesUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ParkingFacilitiesUpdateResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities/{parkingFacilityId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiParkingFacilitiesFindAllAudits = <ThrowOnError extends boolean = false>(
  options: Options<ParkingFacilitiesFindAllAuditsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ParkingFacilitiesFindAllAuditsResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities/{parkingFacilityId}/audits',
    ...options,
  });

export const backendApiParkingFacilitiesFindOneAudit = <ThrowOnError extends boolean = false>(
  options: Options<ParkingFacilitiesFindOneAuditData, ThrowOnError>,
) =>
  (options.client ?? client).get<ParkingFacilitiesFindOneAuditResponses, unknown, ThrowOnError>({
    url: '/api/parking-facilities/{parkingFacilityId}/audits/{auditCreatedAt}',
    ...options,
  });

export const backendApiStationsFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<StationsFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<StationsFindAllResponses, unknown, ThrowOnError>({
    url: '/api/stations',
    ...options,
  });

export const backendApiStationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<StationsCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<StationsCreateResponses, unknown, ThrowOnError>({
    url: '/api/stations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiStationsRemove = <ThrowOnError extends boolean = false>(
  options: Options<StationsRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<StationsRemoveResponses, unknown, ThrowOnError>({
    url: '/api/stations/{stationId}',
    ...options,
  });

export const backendApiStationsFindOne = <ThrowOnError extends boolean = false>(
  options: Options<StationsFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<StationsFindOneResponses, unknown, ThrowOnError>({
    url: '/api/stations/{stationId}',
    ...options,
  });

export const backendApiStationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<StationsUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<StationsUpdateResponses, unknown, ThrowOnError>({
    url: '/api/stations/{stationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiStationsFindAllAudits = <ThrowOnError extends boolean = false>(
  options: Options<StationsFindAllAuditsData, ThrowOnError>,
) =>
  (options.client ?? client).get<StationsFindAllAuditsResponses, unknown, ThrowOnError>({
    url: '/api/stations/{stationId}/audits',
    ...options,
  });

export const backendApiStationsFindOneAudit = <ThrowOnError extends boolean = false>(
  options: Options<StationsFindOneAuditData, ThrowOnError>,
) =>
  (options.client ?? client).get<StationsFindOneAuditResponses, unknown, ThrowOnError>({
    url: '/api/stations/{stationId}/audits/{auditCreatedAt}',
    ...options,
  });

export const backendApiParkAndRideFacilitiesFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<ParkAndRideFacilitiesFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkAndRideFacilitiesFindAllResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities',
    ...options,
  });

export const backendApiParkAndRideFacilitiesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ParkAndRideFacilitiesCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<ParkAndRideFacilitiesCreateResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiParkAndRideFacilitiesExportCsv = <ThrowOnError extends boolean = false>(
  options?: Options<ParkAndRideFacilitiesExportCsvData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkAndRideFacilitiesExportCsvResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities/export.csv',
    ...options,
  });

export const backendApiParkAndRideFacilitiesRemove = <ThrowOnError extends boolean = false>(
  options: Options<ParkAndRideFacilitiesRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ParkAndRideFacilitiesRemoveResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}',
    ...options,
  });

export const backendApiParkAndRideFacilitiesFindOne = <ThrowOnError extends boolean = false>(
  options: Options<ParkAndRideFacilitiesFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<ParkAndRideFacilitiesFindOneResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}',
    ...options,
  });

export const backendApiParkAndRideFacilitiesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ParkAndRideFacilitiesUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ParkAndRideFacilitiesUpdateResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiParkAndRideFacilitiesFindAllAudits = <ThrowOnError extends boolean = false>(
  options: Options<ParkAndRideFacilitiesFindAllAuditsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ParkAndRideFacilitiesFindAllAuditsResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}/audits',
    ...options,
  });

export const backendApiParkAndRideFacilitiesFindOneAudit = <ThrowOnError extends boolean = false>(
  options: Options<ParkAndRideFacilitiesFindOneAuditData, ThrowOnError>,
) =>
  (options.client ?? client).get<ParkAndRideFacilitiesFindOneAuditResponses, unknown, ThrowOnError>({
    url: '/api/park-and-ride-facilities/{parkAndRideFacilityId}/audits/{auditCreatedAt}',
    ...options,
  });

export const backendApiContactRequestsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ContactRequestsCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<ContactRequestsCreateResponses, unknown, ThrowOnError>({
    url: '/api/contact-requests',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiParkingDataFindAllLatestParkingFacilityData = <ThrowOnError extends boolean = false>(
  options?: Options<ParkingDataFindAllLatestParkingFacilityDataData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkingDataFindAllLatestParkingFacilityDataResponses, unknown, ThrowOnError>({
    url: '/api/parking-data/parking-facility/latest',
    ...options,
  });

export const backendApiParkingDataFindAllParkingFacilityData = <ThrowOnError extends boolean = false>(
  options?: Options<ParkingDataFindAllParkingFacilityDataData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkingDataFindAllParkingFacilityDataResponses, unknown, ThrowOnError>({
    url: '/api/parking-data/parking-facility',
    ...options,
  });

export const backendApiParkingDataFindAllLatestParkAndRideFacilityData = <ThrowOnError extends boolean = false>(
  options?: Options<ParkingDataFindAllLatestParkAndRideFacilityDataData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkingDataFindAllLatestParkAndRideFacilityDataResponses, unknown, ThrowOnError>({
    url: '/api/parking-data/park-and-ride-facility/latest',
    ...options,
  });

export const backendApiParkingDataFindAllParkAndRideFacilityData = <ThrowOnError extends boolean = false>(
  options?: Options<ParkingDataFindAllParkAndRideFacilityDataData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ParkingDataFindAllParkAndRideFacilityDataResponses, unknown, ThrowOnError>({
    url: '/api/parking-data/park-and-ride-facility',
    ...options,
  });
